<template>
  <SoDialog
    ref="survey-modal"
    v-model="value"
    :card-title="cardTitle"
    max-width="100%"
    fullscreen
    @on-close="$emit('closeModal')"
  >
    <SoCarousel
      v-if="surveyImages.length"
      :images="surveyImages"
      height="100%"
      data-testid="survey-images-carousel"
    />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoCarousel, { SoCarouselItem } from "@/components/SoCarousel.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoCarousel,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      surveyImages: {
        type: Array as PropType<SoCarouselItem[]>,
        required: true,
      },
    },
    emits: ["update:modelValue", "closeModal"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      cardTitle() {
        return `Survey Photos (${this.surveyImages.length})`
      },
    },
  })
</script>
